<template>
  <v-dialog
    v-model="toggle_data_snowmaking_hydrants_state"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card color="primary">
        <v-btn icon @click="toggleSnowmakingHydrantsListView()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Hydrants</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter hydrant data"
        ></v-text-field>
      </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="computedLiftMaintenanceCablesGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{ props.item.properties.hydrnt_num }}</td>
              <td>{{ props.item.properties.id }}
              <td>{{ props.item.properties.amp30 }}</td>
              <td>{{ props.item.properties.amp60 }}</td>
              <td>{{ props.item.properties.water }}</td>
              <td>{{ props.item.properties.air }}</td>
            </tr>
          </template>

          <!-- Expanding slot below row DOES NOT WORK ATM -->
          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text>Peek-a-boo!</v-card-text>
            </v-card>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>

        </v-data-table>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        search: '',
        rows_per_page: [
          10, 25, 50,
          { 'text': 'All',
            'value': -1
          }
        ],
        rows_per_page_text: 'Per page:',
        headers: [
          {
            text: 'Hydrant #',
            value: 'properties.hydrnt_num'
          },
          {
            text: 'id',
            value: 'properties.id'
          },
          {
            text: '30A',
            value: 'properties.amp30'
          },
          {
            text: '60A',
            value: 'properties.amp60'
          },
          {
            text: 'Water',
            value: 'properties.water'
          },
          {
            text: 'Air',
            value: 'properties.air'
          }
        ]
      }
    },
    computed: {
      computedLiftMaintenanceCablesGeoJsonFeatures () {
        return this.$store.state.layers.snowmaking.mapLayers.hydrants.geojson.features
      },
      toggle_data_snowmaking_hydrants_state: {
        get: function () {
          return this.$store.state.layers.snowmaking.mapLayers.hydrants.visibility.listView
        },
        set: function () {
          this.toggle_data_snowmaking_hydrants()
        }
      }
    },
    methods: {
      toggleSnowmakingHydrantsListView () {
        this.$store.commit('mutationListLayer', {
          dept: 'snowmaking',
          layer: 'hydrants'
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dataSnowmakingHydrants.vue